import { render, staticRenderFns } from "./PaymentReceiptprint.vue?vue&type=template&id=04958ef8&"
import script from "./PaymentReceiptprint.vue?vue&type=script&lang=js&"
export * from "./PaymentReceiptprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports